module.exports = __webpack_public_path__ + "static/media/0158_Medium.41f9ea6d.jpg";